import React from 'react';
import { motion } from 'framer-motion';
import { TOMOS } from './salesData';
export function TomosSection() {
  return <section id="tomos" className="bg-cream py-11 sm:py-14" data-id="element-176" data-mp="1kbix5k4ofekq">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-177" data-mp="1p3tx2mzf30da">
        <div className="text-center" data-id="element-178" data-mp="1p4c0c3khyeup">
          <h2 className="font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-179" data-mp="1u2dimma3ma54">
            200 fórmulas en <span className="text-gold-deep" data-id="element-180" data-mp="xdyv9qudhi7q">4 tomos</span>
          </h2>
        </div>

        <ol className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-181" data-mp="11f0zyn726mh3">
          {TOMOS.map((tomo, i) => <motion.li key={tomo.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.04
        }} className="flex items-center gap-3 rounded-xl border border-stone bg-white px-3.5 py-3" data-id="element-182" data-mp="16c11qlwvl32e" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gold-soft font-display text-[0.95rem] font-extrabold text-gold-deep" data-id="element-183" data-mp="2qnp4qaqfli8b">
                {tomo.num}
              </span>
              <div className="min-w-0" data-id="element-184" data-mp="2hpn6u41zv5p9">
                <h3 className="font-display text-[0.84rem] font-bold leading-tight text-charcoal" data-id="element-185" data-mp="2coz62qnyrahu">
                  {tomo.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.74rem] font-medium tabular-nums text-taupe" data-id="element-186" data-mp="27qnvgdpugvyk">
                  {tomo.range}
                </p>
              </div>
            </motion.li>)}
        </ol>

        <p className="mt-4 text-center font-display text-[0.7rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-187" data-mp="1yuolmlj022hl">
          50 fórmulas por tomo
        </p>
      </div>
    </section>;
}